module.exports = __webpack_public_path__ + "static/landing-2cd19d40631672f929d71ae6b2ccaab9.svg";